// @dynamic-i18n-keys
// sisu.action_popover.body.add_to_group
// sisu.action_popover.body.add_to_private_collection
// sisu.action_popover.body.award_badge
// sisu.action_popover.body.comment
// sisu.action_popover.body.default
// sisu.action_popover.body.download
// sisu.action_popover.body.favourite
// sisu.action_popover.body.report
// sisu.action_popover.body.share_to_post
// sisu.action_popover.body.watch
// sisu.action_popover.title.add_to_group
// sisu.action_popover.title.add_to_private_collection
// sisu.action_popover.title.award_badge
// sisu.action_popover.title.comment
// sisu.action_popover.title.default
// sisu.action_popover.title.download
// sisu.action_popover.title.favourite
// sisu.action_popover.title.report
// sisu.action_popover.title.share_to_post
// sisu.action_popover.title.watch
import type { TFunction } from 'i18next';
import type { SisuActionKey } from '../SisuActionPopover/actionKey';

export function sisuActionPopoverTitle(actionKey: SisuActionKey, t: TFunction): string {
  return t(`sisu.action_popover.title.${actionKey}`);
}

export function sisuActionPopoverBody(actionKey: SisuActionKey, t: TFunction): string {
  return t(`sisu.action_popover.body.${actionKey}`);
}
